import { AccountTreeOutlined, CheckCircleOutline, ErrorOutline } from '@mui/icons-material'
import { Alert, Box, Stack, Typography, alpha, useTheme } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

type ImportSummaryStepProps = {
  successCount: number
  errorCount: number
  hasAiEnrichAutomation?: boolean
}

const ImportSummaryStep: React.FC<ImportSummaryStepProps> = ({ successCount, errorCount, hasAiEnrichAutomation }) => {
  const { formatMessage } = useIntl()
  const { palette } = useTheme()

  return (
    <Stack spacing={2}>
      {successCount > 0 && (
        <Box
          sx={{
            bgcolor: alpha(palette.success.main, 0.2),
            p: 2,
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <CheckCircleOutline sx={{ color: 'brandDecorative.emerald' }} />
          <Typography variant="subtitle1">
            {formatMessage({ id: 'import.summary.successfullyImported' }, { count: successCount })}
          </Typography>
        </Box>
      )}

      {errorCount > 0 && (
        <Box
          sx={{
            bgcolor: alpha(palette.error.main, 0.2),
            p: 2,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 2,
          }}
        >
          <ErrorOutline sx={{ color: 'semantic.error' }} />
          <Stack>
            <Typography variant="subtitle1">
              {formatMessage({ id: 'import.summary.failedToImport' }, { count: errorCount })}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {formatMessage({ id: 'import.summary.manageErrorsInFinalStep' })}
            </Typography>
          </Stack>
        </Box>
      )}

      {hasAiEnrichAutomation && successCount > 0 && (
        <Alert severity="info" icon={<AccountTreeOutlined />}>
          {formatMessage({ id: 'import.summary.aiEnrichAutomationInfo' })}
        </Alert>
      )}
    </Stack>
  )
}

export default ImportSummaryStep
